import { z } from "zod";

export const inviteUsersSchema = z.object({
	emails: z.email().array(),
});

export type InviteUsersSchema = z.infer<typeof inviteUsersSchema>;
